import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://auzfgedsysmqnpryudcg.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF1emZnZWRzeXNtcW5wcnl1ZGNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgxNDg3MTAsImV4cCI6MjA2MzcyNDcxMH0.l092wD3-XFvxXQWppjz45ZIoZ0Nhllru0cFbfUt4iMw'

// Client untuk operasi normal (tanpa auth - untuk admin/internal)
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: false,
    persistSession: false,
    detectSessionInUrl: false
  },
  realtime: {
    heartbeatIntervalMs: 30000
  }
})

// Client untuk customer auth (dengan session persistence)
export const supabaseAuth = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'snapme-customer-auth'
  },
  realtime: {
    heartbeatIntervalMs: 30000
  }
}) 
